import { useEffect, useRef, useState, type ReactElement } from "react";
import { EXPORT_FORMAT_OPTIONS } from "../../src/export-formats.js";
import type { ExportFormat } from "../../src/contracts.js";

type VideoFormatSelectionMobileProps = {
  value: ExportFormat;
  disabled: boolean;
  onChange: (format: ExportFormat) => void;
};

/** Mobile-only format control placed with the other creative settings. */
export function VideoFormatSelectionMobile({ value, disabled, onChange }: VideoFormatSelectionMobileProps): ReactElement {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const selected = EXPORT_FORMAT_OPTIONS.find((format) => format.id === value) ?? EXPORT_FORMAT_OPTIONS[0]!;

  useEffect(() => {
    const closeWhenOutside = (event: PointerEvent) => {
      if (!menuRef.current?.contains(event.target as Node)) setIsOpen(false);
    };
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setIsOpen(false);
    };
    document.addEventListener("pointerdown", closeWhenOutside);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeWhenOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);

  return <section className="video-format-selection-mobile" aria-labelledby="mobile-video-format-title">
    <h3 id="mobile-video-format-title">Video format</h3>
    <p>Choose the best format for your platform.</p>
    <div className="mobile-video-format-select" ref={menuRef}>
      <button type="button" aria-haspopup="listbox" aria-expanded={isOpen} disabled={disabled} onClick={() => setIsOpen((open) => !open)}><span aria-hidden="true">▣</span><strong>{selected.label} ({selected.aspectLabel})</strong><i aria-hidden="true"/></button>
      {isOpen ? <ul role="listbox" aria-label="Video format">{EXPORT_FORMAT_OPTIONS.map((format) => <li key={format.id} role="option" aria-selected={format.id === value}><button type="button" onClick={() => { onChange(format.id); setIsOpen(false); }}><span aria-hidden="true">{format.id === value ? "✓" : ""}</span>{format.label} ({format.aspectLabel})</button></li>)}</ul> : null}
    </div>
  </section>;
}
